import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M9.428 20a8.95 8.95 0 0 1-3.913-2.483c.396-.49.635-1.12.635-1.81 0-1.552-1.209-2.81-2.7-2.81q-.136 0-.267.014a9.8 9.8 0 0 1 .23-4.695h.037c1.491 0 2.7-1.258 2.7-2.81 0-.445-.1-.866-.277-1.24A8.9 8.9 0 0 1 9.593 2c.447.91 1.357 1.534 2.407 1.534S13.96 2.911 14.407 2a8.9 8.9 0 0 1 3.72 2.166 2.9 2.9 0 0 0-.277 1.24c0 1.552 1.209 2.81 2.7 2.81h.038a9.77 9.77 0 0 1 .23 4.695 3 3 0 0 0-.268-.014c-1.491 0-2.7 1.258-2.7 2.81 0 .69.239 1.32.635 1.81C17.423 18.666 16.508 19.533 15 20c-1-1-1.796-1.953-3-1.953s-2.224.82-2.572 1.953Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M12 14.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "16",
  cy: "16",
  r: "6",
  fill: "#fff"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M16 20.375a4.375 4.375 0 1 0 0-8.75 4.375 4.375 0 0 0 0 8.75m-2.187-4.246.441-.442 1.121 1.121 2.37-2.37.442.442-2.812 2.812z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }